import React from 'react';
import { FamlyEnquiryLink } from './FamlyEnquiryLink';

/**
 * The enquiry call to action on /contact, in place of the old email form.
 * Enquiries and application forms both live in Famly so they can be tracked
 * and replied to in one place.
 */
export const FamlyEnquiryPanel: React.FC = () => (
  <div className="max-w-3xl mx-auto bg-stone-100 border border-slate-300 rounded-3xl p-8 md:p-12 text-center">
    <h2 className="text-3xl font-semibold text-slate-700 mb-4">Enquire about a place</h2>
    <p className="text-slate-600 mb-8">
      We use Famly to handle enquiries and application forms, so everything stays in one
      place and we can get back to you quickly. Tell us about your child and we'll be in
      touch about availability, a visit and next steps.
    </p>

    <FamlyEnquiryLink
      ctaLocation="contact_page"
      className="inline-block bg-lime-500 hover:bg-lime-600 text-white visited:text-white hover:text-white focus:text-white active:text-white no-underline hover:no-underline text-lg font-medium px-8 py-3 rounded-full transition"
    >
      Start your enquiry
    </FamlyEnquiryLink>

    <p className="text-sm text-slate-500 mt-4">Opens the Famly enquiry form in a new tab.</p>

    <p className="text-slate-600 mt-8 mb-0">
      Prefer to talk to us? Call, WhatsApp or email your nearest nursery using the details
      below.
    </p>
  </div>
);
